import type { ChangeEvent, FocusEvent } from "react";
import { Input, Button } from "@porchpass/ui";

interface ResetPasswordFormProps {
  value: string;
  showError: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  onFocus: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur: (event: FocusEvent<HTMLInputElement>) => void;
  loading: boolean;
}

export const ForgotPasswordForm: React.FC<ResetPasswordFormProps> = ({
  value,
  showError,
  onChange,
  onSubmit,
  onFocus,
  onBlur,
  loading,
}) => (
  <form
    className="flex flex-col gap-4 w-full"
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    <Input
      value={value}
      placeholder="Email"
      error={showError}
      helperText={showError ? "Email is invalid" : undefined}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      size="s"
      type="email"
    />

    <Button
      variant="primary"
      size="m"
      type="submit"
      loading={loading}
      className="w-full"
    >
      Send reset instructions
    </Button>
  </form>
);
